import Konva from 'konva'
import {
  MIN_SIZE,
  TEXT_FONT_FAMILY,
  TEXT_LINE_HEIGHT,
  TEXT_PADDING_X,
  TEXT_PADDING_Y,
} from '../constants'

let measurer: Konva.Text | null = null

export const measureTextBoxHeightPx = (
  text: string,
  boxWidthPx: number,
  fontSizePx: number,
) => {
  if (!measurer) measurer = new Konva.Text({ listening: false })
  measurer.setAttrs({
    text: text || 'Text',
    width: Math.max(1, boxWidthPx - TEXT_PADDING_X * 2),
    fontSize: fontSizePx,
    fontFamily: TEXT_FONT_FAMILY,
    lineHeight: TEXT_LINE_HEIGHT,
    align: 'center',
    wrap: 'word',
    padding: 0,
  })
  const contentHeight = Math.max(
    measurer.height(),
    fontSizePx * TEXT_LINE_HEIGHT,
  )
  return contentHeight + TEXT_PADDING_Y * 2
}

export const reflowTextGroup = (group: Konva.Group) => {
  const scaleX = group.scaleX()
  const nextWidth = Math.max(MIN_SIZE, group.width() * Math.abs(scaleX))
  group.scaleX(1)
  group.scaleY(1)
  group.width(nextWidth)

  const text = group.findOne('Text') as Konva.Text | undefined
  const rect = group.findOne('Rect') as Konva.Rect | undefined
  if (text) text.width(Math.max(1, nextWidth - TEXT_PADDING_X * 2))

  const contentHeight = text
    ? Math.max(text.height(), text.fontSize() * TEXT_LINE_HEIGHT)
    : 0
  const nextHeight = contentHeight + TEXT_PADDING_Y * 2

  group.height(nextHeight)
  group.offsetX(nextWidth / 2)
  group.offsetY(nextHeight / 2)
  group.clipX(0)
  group.clipY(0)
  group.clipWidth(nextWidth)
  group.clipHeight(nextHeight)

  rect?.width(nextWidth)
  rect?.height(nextHeight)
}
